import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DisplayStage } from '../../beneficiaries/beneficiary-folder/stages/displayStage';
import { Stage } from '../../beneficiaries/beneficiary-folder/stages/stage';
import { environment } from '../../environments/environment';
import { StageSaveDto } from '../../stages/stageSaveDto';
import { Pagination } from '../pagination/pagination';
import { PaginationOptions } from '../pagination/pagination-options';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class StagesService {
  private readonly stageCreate: Subject<StageSaveDto> = new Subject<StageSaveDto>();
  public stageCreated$: Observable<StageSaveDto> = this.stageCreate.asObservable();
  private readonly stageUpdate: Subject<StageSaveDto> = new Subject<StageSaveDto>();
  public stageUpdate$: Observable<StageSaveDto> = this.stageUpdate.asObservable();
  private readonly stageDelete: Subject<number> = new Subject<number>();
  public stageDeleted$: Observable<number> = this.stageDelete.asObservable();

  constructor(private readonly api: ApiService) {}

  public async findByBeneficiaryId(id: number, options: PaginationOptions): Promise<Pagination<DisplayStage>> {
    const uri: string = environment.api.stages + '/' + id;
    return this.api.getPaginated<DisplayStage>(options.buildUrl(uri));
  }

  public async findByCommunityActionId(id: number, options: PaginationOptions): Promise<Pagination<DisplayStage>> {
    const uri: string = environment.api.stages + '/communityAction/' + id;
    return this.api.getPaginated<DisplayStage>(options.buildUrl(uri));
  }

  public async findByStageId(idStage: number): Promise<Stage> {
    const uri: string = environment.api.stages + '/' + idStage + '/details';
    const result: Stage = await this.api.get<Stage>(uri);
    return Stage.fromJson(result);
  }

  public async saveStage(stage: StageSaveDto, accessMode: string): Promise<void> {
    await this.api.post(environment.api.stages + `/${accessMode ? '?accessMode=' + accessMode : ''}`, stage);
    this.stageCreate.next(stage);
  }

  public async updateStage(idStage: number, stage: StageSaveDto, accessMode: string): Promise<void> {
    const uri: string = environment.api.stages + '/' + idStage + `/${accessMode ? '?accessMode=' + accessMode : ''}`;
    await this.api.put(uri, stage);
    this.stageUpdate.next(stage);
  }

  public async deleteStage(idStage: number): Promise<void> {
    const uri: string = environment.api.stages + '/' + idStage;
    await this.api.delete(uri);
    this.stageDelete.next(idStage);
  }
}
